
	/**
	 * @description
	 *	Representa un error generado al intentar construir, consultar u
	 *	obtener el resultado de un job asincrónico.
	 */

export class AsyncJobError extends Error {

	public payload: any;

	public constructor(message: string, payload: any) {
		super();
		this.message = message;
		this.name = "AsyncJobError";
		this.payload = payload;
	}
}
